import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _objectSpread from "@babel/runtime/helpers/objectSpread";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";

/* eslint-disable class-methods-use-this */

/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { ApolloError } from "apollo-client";
import { fireSignOut, getAuthToken, setAuthToken } from "../auth";
import { MUTATIONS } from "../mutations";
import { QUERIES } from "../queries";
import { getErrorsFromData, getMappedData, isDataEmpty, mergeEdges } from "../utils";
export var APIProxy =
/*#__PURE__*/
function () {
  // getAttributes = this.watchQuery(QUERIES.Attributes, data => data.attributes);
  // getProductList = this.watchQuery(QUERIES.ProductList, data => data.products);
  // getCategoryDetails = this.watchQuery(
  //  QUERIES.CategoryDetails,
  //  data => data.category
  // );
  // getVariantsProducts = this.watchQuery(
  //  QUERIES.VariantsProducts,
  //  data => data.productVariants
  // );
  function APIProxy(client) {
    var _this = this;

    _classCallCheck(this, APIProxy);

    this.getProductDetails = this.watchQuery(QUERIES.ProductDetails, function (data) {
      return data.product;
    });
    this.getOrdersByUser = this.watchQuery(QUERIES.OrdersByUser, function (data) {
      return data.me ? data.me.orders : null;
    });
    this.getOrderDetails = this.watchQuery(QUERIES.OrderDetails, function (data) {
      return data.orderByToken;
    });
    this.getShopDetails = this.watchQuery(QUERIES.GetShopDetails, function (data) {
      return data;
    });
    this.getUserWishlist = this.watchQuery(QUERIES.Wishlist, function (data) {
      return data.wishlist ? data.wishlist.items : null;
    });
    this.setUserDefaultAddress = this.fireQuery(MUTATIONS.AddressTypeUpdate, function (data) {
      return data.accountSetDefaultAddress;
    });
    this.setDeleteUserAddress = this.fireQuery(MUTATIONS.DeleteUserAddress, function (data) {
      return data.accountAddressDelete;
    });
    this.setCreateUserAddress = this.fireQuery(MUTATIONS.CreateUserAddress, function (data) {
      return data.accountAddressCreate;
    });
    this.setUpdateuserAddress = this.fireQuery(MUTATIONS.UpdateUserAddress, function (data) {
      return data.accountAddressUpdate;
    });
    this.setAddWishlistProductVariant = this.fireQuery(MUTATIONS.AddWishlistProductVariant, function (data) {
      return data.wishlistAddVariant;
    });
    this.setRemoveWishlistProductVariant = this.fireQuery(MUTATIONS.RemoveWishlistProductVariant, function (data) {
      return data.wishlistRemoveVariant;
    });
    this.setAccountUpdate = this.fireQuery(MUTATIONS.AccountUpdate, function (data) {
      return data.accountUpdate;
    });

    this.getUserDetails = function (variables, options) {
      if (_this.isLoggedIn()) {
        return _this.watchQuery(QUERIES.UserDetails, function (data) {
          return data.me;
        })(variables, options);
      }

      if (options.onUpdate) {
        options.onUpdate(null);
      }

      return {
        refetch: function refetch() {
          return new Promise(function (resolve, _reject) {
            resolve({
              data: null
            });
          });
        },
        unsubscribe: function unsubscribe() {
          return undefined;
        }
      };
    };

    this.signIn =
    /*#__PURE__*/
    function () {
      var _ref = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(variables, options) {
        var result, _result, data;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.client.resetStore();

              case 2:
                result = null;
                _context.next = 5;
                return _this.fireQuery(MUTATIONS.TokenAuth, function (mutationData) {
                  return mutationData.tokenCreate;
                })(variables, _objectSpread({}, options, {
                  fetchPolicy: "no-cache"
                }));

              case 5:
                result = _context.sent;
                _result = result, data = _result.data;

                if ((data === null || data === void 0 ? void 0 : data.token) && data.errors.length === 0) {
                  setAuthToken(data.token);

                  if (window.PasswordCredential && variables) {
                    navigator.credentials.store(new window.PasswordCredential({
                      id: variables.email,
                      password: variables.password
                    }));
                  }
                }

                return _context.abrupt("return", {
                  data: data,
                  error: null
                });

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }();

    this.signOut = function () {
      return new Promise(function (resolve, reject) {
        try {
          fireSignOut(_this.client);
          resolve();
        } catch (e) {
          reject(e);
        }
      });
    };

    this.setPassword =
    /*#__PURE__*/
    function () {
      var _ref2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(variables, options) {
        var result, _result2, data;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                result = null;
                _context2.next = 3;
                return _this.fireQuery(MUTATIONS.SetPassword, function (d) {
                  return d;
                })(variables, _objectSpread({}, options, {
                  fetchPolicy: "no-cache"
                }));

              case 3:
                result = _context2.sent;
                _result2 = result, data = _result2.data;
                return _context2.abrupt("return", {
                  data: data,
                  error: null
                });

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x3, _x4) {
        return _ref2.apply(this, arguments);
      };
    }();

    this.setPasswordChange =
    /*#__PURE__*/
    function () {
      var _ref3 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(variables, options) {
        var result, _result3, data;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                result = null;
                _context3.next = 3;
                return _this.fireQuery(MUTATIONS.PasswordChange, function (d) {
                  return d;
                })(variables, _objectSpread({}, options, {
                  fetchPolicy: "no-cache"
                }));

              case 3:
                result = _context3.sent;
                _result3 = result, data = _result3.data;
                return _context3.abrupt("return", {
                  data: data,
                  error: null
                });

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function (_x5, _x6) {
        return _ref3.apply(this, arguments);
      };
    }();

    this.attachAuthListener = function (callback) {
      var eventHandler = function eventHandler() {
        callback(_this.isLoggedIn());
      };

      window.addEventListener("auth", eventHandler);
      return function () {
        window.removeEventListener("auth", eventHandler);
      };
    };

    this.isLoggedIn = function () {
      return !!getAuthToken();
    };

    this.client = client;
  }

  _createClass(APIProxy, [{
    key: "watchQuery",
    value: function watchQuery(query, mapFn) {
      var _this2 = this;

      return function (variables, options) {
        var onComplete = options.onComplete,
            onError = options.onError,
            onUpdate = options.onUpdate,
            apolloClientOptions = _objectWithoutProperties(options, ["onComplete", "onError", "onUpdate"]);

        var observable = query(_this2.client, _objectSpread({}, apolloClientOptions, {
          variables: variables
        }));

        if (options.skip) {
          return {
            refetch: function refetch(_variables) {
              return new Promise(function (resolve, _reject) {
                resolve({
                  data: null
                });
              });
            },
            unsubscribe: null
          };
        }

        var subscription = observable.subscribe(function (result) {
          var data = result.data,
              apolloErrors = result.errors;
          var errorHandledData = handleDataErrors(mapFn, data, apolloErrors);

          if (onUpdate) {
            if (errorHandledData.errors) {
              if (onError) {
                onError(errorHandledData.errors);
              }
            } else {
              onUpdate(errorHandledData.data);

              if (onComplete) {
                onComplete();
              }
            }
          }
        }, function (error) {
          if (onError) {
            onError(error);
          }
        });
        return {
          loadMore: function loadMore(extraVariables) {
            var mergeResults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
            observable.fetchMore({
              updateQuery: function updateQuery(previousResult, _ref4) {
                var fetchMoreResult = _ref4.fetchMoreResult;
                var prevResult = previousResult || observable.getLastResult().data;

                if (!fetchMoreResult) {
                  // returning previousResult doesn't trigger observable `next`
                  onUpdate(mapFn(prevResult));
                  return prevResult;
                }

                if (mergeResults) {
                  var prevResultRef = mapFn(prevResult);
                  var newResultRef = mapFn(fetchMoreResult);

                  if (!prevResultRef || !newResultRef) {
                    onUpdate(prevResultRef);
                    return prevResult;
                  }

                  var mergedEdges = mergeEdges(prevResultRef.edges, newResultRef.edges); // use new result for metadata and mutate existing data

                  Object.keys(prevResultRef).forEach(function (key) {
                    prevResultRef[key] = newResultRef[key];
                  });
                  prevResultRef.edges = mergedEdges;
                  return prevResult;
                }

                return fetchMoreResult;
              },
              variables: _objectSpread({}, variables, extraVariables)
            });
          },
          refetch: function refetch(vars) {
            if (vars) {
              observable.setVariables(vars);
              var cachedResult = observable.currentResult();
              var errorHandledData = handleDataErrors(mapFn, cachedResult.data);

              if (errorHandledData.data) {
                onUpdate(errorHandledData.data);
              }
            }

            return _this2.firePromise(function () {
              return observable.refetch(vars);
            }, mapFn);
          },
          setOptions: function setOptions(newOptions) {
            return _this2.firePromise(function () {
              return observable.setOptions(newOptions);
            }, mapFn);
          },
          unsubscribe: subscription.unsubscribe.bind(subscription)
        };
      };
    }
  }, {
    key: "fireQuery",
    value: function fireQuery(query, mapFn) {
      var _this3 = this;

      return function (variables, options) {
        return _this3.firePromise(function () {
          return query(_this3.client, _objectSpread({}, options, {
            variables: variables
          }));
        }, mapFn);
      };
    } // Promise wrapper to catch errors

  }, {
    key: "firePromise",
    value: function firePromise(promise, mapFn) {
      return new Promise(function (resolve, reject) {
        var f =
        /*#__PURE__*/
        function () {
          var _ref5 = _asyncToGenerator(
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee4() {
            var _ref6, _data, apolloErrors, errorHandledData;

            return _regeneratorRuntime.wrap(function _callee4$(_context4) {
              while (1) {
                switch (_context4.prev = _context4.next) {
                  case 0:
                    _context4.prev = 0;
                    _context4.next = 3;
                    return promise();

                  case 3:
                    _ref6 = _context4.sent;
                    _data = _ref6.data;
                    apolloErrors = _ref6.errors;
                    errorHandledData = handleDataErrors(mapFn, _data, apolloErrors);

                    if (errorHandledData.errors) {
                      reject(errorHandledData.errors);
                    }

                    resolve({
                      data: errorHandledData.data
                    });
                    _context4.next = 14;
                    break;

                  case 11:
                    _context4.prev = 11;
                    _context4.t0 = _context4["catch"](0);
                    reject(_context4.t0);

                  case 14:
                  case "end":
                    return _context4.stop();
                }
              }
            }, _callee4, null, [[0, 11]]);
          }));

          return function f() {
            return _ref5.apply(this, arguments);
          };
        }();

        f();
      });
    }
  }]);

  return APIProxy;
}(); // error handler

var handleDataErrors = function handleDataErrors(mapFn, data, apolloErrors) {
  // INFO: user input errors will be moved to graphql errors
  var userInputErrors = getErrorsFromData(data);
  var errors = apolloErrors || userInputErrors ? new ApolloError({
    extraInfo: userInputErrors,
    graphQLErrors: apolloErrors
  }) : null;

  if (errors && isDataEmpty(data)) {
    return {
      errors: errors,
      data: null
    };
  }

  var result = getMappedData(mapFn, data);
  return {
    data: result,
    errors: null
  };
};